/**
 * reflects api key access admin dto on server.
 * The contract never sends a key value, prefix or suffix, and nothing may be added here that could carry one.
 */
import {Dto} from 'common';
import {ApiKeyAccessState} from '../models/apiKeyAccessState';

export class ApiKeyAccessAdminDto extends Dto {
    accountCode: string;
    state: string;
    requestedOn: number;
    grantedOn: number;
    grantedBy: string;
    grantedByEmail: string;
    withdrawnOn: number;
    withdrawnBy: string;
    withdrawnByEmail: string;
    activeKeyCount: number;
    /**
     * Present on the withdraw response only. Undefined on a read.
     */
    revokedKeyCount: number;

    private static toDate(timestamp: number): Date | undefined {
        if (!timestamp) {
            return undefined;
        }
        return new Date(timestamp);
    }

    public deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }

    /**
     * undefined when the server sends a state this console does not know about.
     * That is tolerated on purpose: the section then shows the raw value and offers no action.
     *
     * Only own members of the enum count. A plain index would also resolve the inherited members of
     * Object.prototype, so a state of 'constructor' or 'toString' would look recognised and skip the
     * honest unrecognised state branch.
     */
    public get stateType(): ApiKeyAccessState {
        if (!Object.prototype.hasOwnProperty.call(ApiKeyAccessState, this.state)) {
            return undefined;
        }
        return ApiKeyAccessState[this.state];
    }

    /**
     * undefined when it never happened, so the view can show nothing at all instead of 1 January 1970.
     */
    public get requestedOnDate(): Date | undefined {
        return ApiKeyAccessAdminDto.toDate(this.requestedOn);
    }

    public get grantedOnDate(): Date | undefined {
        return ApiKeyAccessAdminDto.toDate(this.grantedOn);
    }

    public get withdrawnOnDate(): Date | undefined {
        return ApiKeyAccessAdminDto.toDate(this.withdrawnOn);
    }
}
